@import "../../../variables";

.header {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
}

.cardList {
  display: flex;
  gap: 5px;
  overflow-x: auto;
  white-space: nowrap;
  padding-bottom: 8px;
}

.cardList::-webkit-scrollbar {
  height: 6px;
}

.cardList::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 3px;
}
